import React, { useContext } from "react";
import { PageHero, DraftNotice } from "@/components/common/SectionHeading";
import { SettingsContext } from "@/components/layout/SettingsContext";
import { Smartphone } from "lucide-react";

export default function MobileApp() {
    const s = useContext(SettingsContext);
    return (
        <div data-testid="mobile-app-page">
            <PageHero eyebrow="Mobile application" title="LNL Mobile App" description="Access announcements, updates and school information on the go." breadcrumbs={[{label:"Home",to:"/"},{label:"Mobile App"}]} />
            <section className="py-10 bg-white">
                <div className="lnl-container max-w-3xl grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div className="lnl-card p-6">
                        <Smartphone className="h-8 w-8 text-lnl-green" />
                        <div className="font-heading font-bold text-xl text-lnl-charcoal mt-3">Stay updated anywhere</div>
                        <div className="text-sm text-lnl-gray mt-2">The LNL mobile application is designed to help students and parents access announcements, updates, calendar information and common school information.</div>
                        <DraftNotice tone="info">The app does not currently handle admissions unless LNL confirms that functionality.</DraftNotice>
                    </div>
                    <div className="lnl-card p-6">
                        <div className="lnl-eyebrow">Download</div>
                        <div className="mt-2 text-sm text-lnl-gray">Store links are managed by administrators. Android package: <code className="text-lnl-charcoal">{s?.android_package || "com.wela.lnl"}</code></div>
                        <div className="mt-4 flex flex-col gap-2">
                            <a href="#" className="lnl-btn-primary" data-testid="download-android">Download for Android</a>
                            <a href="#" className="lnl-btn-secondary" data-testid="download-ios">Download for iPhone / iPad</a>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}
